import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Module.style';

const Module = ({ children, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);

  return (
    <div className={className} {...other}>
      {children}
    </div>
  );
};

Module.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Module.defaultProps = {
  className: '',
};

export default Module;
